/*
 * @Author: zhangliang
 * @Date: 2020-01-30 19:35:33
 * @LastEditTime: 2020-03-06 21:28:46
 * @LastEditors: zhangliang
 * @Description: 
 * @FilePath: \asset_app\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
import axios from 'axios'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import toast from './components/Toast'
import './assets/font/iconfont.css' // 字体图标文件
// 调试工具
if (process.env.NODE_ENV !== 'production') {
  const Vconsole = require('vconsole')
  // new Vconsole()
}

// 引入chart
require('echarts/lib/chart/pie') // 引入折线图等组件
require('echarts/lib/component/tooltip') // 引入提示框和title组件，图例
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
let echarts = require('echarts/lib/echarts') //引入基本模板
Vue.prototype.$echarts = echarts
Vue.use(toast)
Vue.use(ElementUI)
Vue.config.productionTip = false

// get serverConfig.json
function getServerConfig() {
  return new Promise(function (resolve, reject) {
    axios.get("serverconfig.json?t=" + new Date().getTime()).then((result) => {
      resolve(result)
    }).catch((error) => {
      reject(error)
    });
  })
}

// 初始化vue
async function initVue() {
  axios.defaults.timeout = 5000
  let result = await getServerConfig()
  axios.defaults.baseURL = result.data.ApiUrl

  // if (process.env.NODE_ENV === 'production') {
  //   let result = await getServerConfig()
  //   axios.defaults.baseURL = result.data.ApiUrl
  // } else {
  //   axios.defaults.baseURL = process.env.VUE_APP_CURENV
  // }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

initVue()